import React from 'react';
import styles from './styles.module.css';
import { Select, Alert } from 'antd';
import { getLangKey } from '../../../../../../javascript/models/Language';
import * as translations from './strings';
import { Info } from 'lucide-react';
import cx from 'classnames';
import DetailsLabel from '../DetailsLabel';
import { onArticleClick } from '../../../../../../redesign/javascript/utils/HelpArticleButton';

const strings = translations[getLangKey()];

const { Option } = Select;

type Props = {
  guestVisible: boolean;
  updateVisibility: (visibility: boolean) => void;
  hasGuestWatchers: boolean;
};

type VisibleOption = {
  label: string;
  value: boolean;
};

const VisibleTo = ({
  guestVisible,
  updateVisibility,
  hasGuestWatchers
}: Props) => (
  <div className={styles.visibleToOuter}>
    <div className={styles.visibleToLabelAndControls}>
      <DetailsLabel label={strings.visibleTo} />
      <Select
        className={styles.visibleToSelect}
        value={guestVisible}
        onSelect={updateVisibility}
        optionLabelProp="label"
        getPopupContainer={trigger => trigger.parentElement}
        popupMatchSelectWidth={false}
      >
        {[
          { label: strings.members, value: false },
          { label: strings.membersAndGuests, value: true }
        ].map(({ value, label }: VisibleOption, index: number) => (
          <Option
            className={cx(styles.visibleOption, styles.withLink)}
            key={`${value}-${index}`}
            value={value}
            label={label}
          >
            {label}
            {value && (
              <Info
                onClick={onArticleClick.bind(null, { articleId: 84898 })}
                className={styles.infoIcon}
              />
            )}
          </Option>
        ))}
      </Select>
    </div>
    {!guestVisible && hasGuestWatchers && (
      <Alert
        message={
          <>
            {strings.guestWatchersAlertMessage}
            <span className={styles.membersOnly}>{strings.membersOnly}</span>
          </>
        }
        description={
          <>
            {strings.allowClients}
            <span className={styles.membersAndClients}>
              {strings.membersAndClients}
            </span>
          </>
        }
        closable
        type="info"
        showIcon
        className={styles.guestWatchersAlert}
      />
    )}
  </div>
);

export default VisibleTo;
